// Generic constraint to ensure items have an organization with an id
type WithOrganization = {
  organization?: {
    id: string;
  } | null;
};

export const filterByOrganizations = <T extends WithOrganization>(data: T[], organizationId: string | null): T[] => {
  if (!organizationId) {
    return data;
  }

  return data.filter(item => {
    if (item.organization?.id) {
      return item.organization.id === organizationId;
    }

    return false;
  });
};
